import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ArticleListComponent } from './article-list/article-list.component';
import { ArticleComponent } from './article/article.component';
import { NewsComponent } from './news.component';


const routes: Routes = [
  {
    path: '',
    component: NewsComponent,
    children: [

      {
        path: ':id',
        component: ArticleListComponent,

      },
      {
        path: ':id/article/:id',
        component: ArticleComponent,
      },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewsRoutingModule { }

export const routedComponents = [
  NewsComponent,
  ArticleListComponent,
  ArticleComponent
];



// WEBPACK FOOTER //
// ./src/app/news/news-routing.module.ts